import { Link } from "react-router-dom";
import QuoteModal from "../components/QuoteModal";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="main-footer">
        {/* Footer Background Images */}
        <div className="section-bg-images">
          <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/42-hexagon.svg')" }} data-aos="flip-down" data-aos-delay="100" data-aos-duration="800"></div>
          <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/31-star-5point.svg')" }} data-aos="rotate-left" data-aos-delay="200" data-aos-duration="1000"></div>
          <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/11-circle-basic.svg')" }} data-aos="rotate-right" data-aos-delay="300" data-aos-duration="1200"></div>
          <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/75-shield.svg')" }} data-aos="fade-up" data-aos-delay="400" data-aos-duration="1400"></div>
          <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/95-layered-circles.svg')" }} data-aos="fade-down" data-aos-delay="500" data-aos-duration="800"></div>
          <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/63-diamond.svg')" }} data-aos="fade-left" data-aos-delay="600" data-aos-duration="1000"></div>
          <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/83-rounded-squircle.svg')" }} data-aos="fade-right" data-aos-delay="700" data-aos-duration="1200"></div>
          <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/89-gear.svg')" }} data-aos="zoom-in" data-aos-delay="800" data-aos-duration="1400"></div>
          <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/47-hexagon-outline.svg')" }} data-aos="zoom-out" data-aos-delay="900" data-aos-duration="800"></div>
        </div>
        <div className="container">
          <div className="footer-top">
            <div className="footer-brand">
              <div className="footer-logo">
                <img src="/assets/img/callsoft-logo.png" alt="Callsoft BD" style={{ maxWidth: "250px" }} />
              </div>
              <p className="footer-desc">
                Callsoftbd is a trusted provider of professional IT products
                and services in the Bangladesh. We specialize in enterprise software,
                bespoke web &amp; mobile development, VPS hosting, cloud migrations,
                AI integrations, and comprehensive cybersecurity audits.{" "}
                <Link to="/about">Read More</Link>
              </p>
            </div>
            <div className="footer-top-widgets">
              <div className="footer-widget">
                <h3>Capabilities</h3>
                <div className="footer-menu">
                  <ul>
                    <li><Link to="/services/web-app-development"><i className="fa fa-angle-right"></i><span>Web &amp; App Development</span></Link></li>
                    <li><Link to="/services/ui-ux-design"><i className="fa fa-angle-right"></i><span>UI/UX Design</span></Link></li>
                    <li><Link to="/services/cloud-devops"><i className="fa fa-angle-right"></i><span>Cloud &amp; DevOps</span></Link></li>
                    <li><Link to="/services/vps-hosting"><i className="fa fa-angle-right"></i><span>VPS &amp; Hosting</span></Link></li>
                    <li><Link to="/services/aws-cloud-platforms"><i className="fa fa-angle-right"></i><span>AWS &amp; Cloud Platforms</span></Link></li>
                    <li><Link to="/services/server-management"><i className="fa fa-angle-right"></i><span>Server Management</span></Link></li>
                    <li><Link to="/services/ai-data"><i className="fa fa-angle-right"></i><span>AI &amp; Data Solutions</span></Link></li>
                    <li><Link to="/services/cybersecurity"><i className="fa fa-angle-right"></i><span>Cybersecurity Audits</span></Link></li>
                  </ul>
                </div>
              </div>
              <div className="footer-widget">
                <h3>Quick Links</h3>
                <div className="footer-menu">
                  <ul>
                    <li><Link to="/"><i className="fa fa-angle-right"></i><span>Home</span></Link></li>
                    <li><Link to="/about"><i className="fa fa-angle-right"></i><span>About Us</span></Link></li>
                    <li><Link to="/#services"><i className="fa fa-angle-right"></i><span>Capabilities</span></Link></li>
                    <li><Link to="/gallery"><i className="fa fa-angle-right"></i><span>Gallery</span></Link></li>
                    <li><Link to="/contact"><i className="fa fa-angle-right"></i><span>Contact Us</span></Link></li>
                  </ul>
                </div>
              </div>
              <div className="footer-widget">
                <h3>Contact Info</h3>
                <ul className="corporate-address">
                  <li>
                    <a href="#">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="var(--color-primary)" d="M12 11.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7" />
                      </svg>
                      <span>Callsoftbd<br />Dhaka, <br />Bangladesh</span>
                    </a>
                  </li>
                  <li>
                    <a href="tel:+8801839602840">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="var(--color-primary)" d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24c1.12.37 2.33.57 3.57.57c.55 0 1 .45 1 1V20c0 .55-.45 1-1 1c-9.39 0-17-7.61-17-17c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02z" />
                      </svg>
                      <span>+880 1839-602840</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.callsoftbd.com" target="_blank" rel="noopener noreferrer">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="var(--color-primary)" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93c0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41c0 2.08-.8 3.97-2.1 5.39z" />
                      </svg>
                      <span>www.callsoftbd.com</span>
                    </a>
                  </li>
                  <li>
                    <a href="mailto:info@callsoftbd.com">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="none" stroke="var(--color-primary)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m2.357 7.714l6.98 4.654c.963.641 1.444.962 1.964 1.087c.46.11.939.11 1.398 0c.52-.125 1.001-.446 1.964-1.087l6.98-4.654M7.157 19.5h9.686c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.31-1.311c.328-.642.328-1.482.328-3.162V9.3c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311c-.642-.327-1.482-.327-3.162-.327H7.157c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.31 1.311c-.328.642-.328 1.482-.328 3.162v5.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311c.642.327 1.482.327 3.162.327" />
                      </svg>
                      <span>info@callsoftbd.com</span>
                    </a>
                  </li>
                </ul>
                <div className="footer-socials">
                  <a href="https://www.facebook.com/CallsoftbdBangladesh" target="_blank" rel="noopener noreferrer"><i className="jsocial-facebook"></i></a>
                  <a href="#"><i className="jsocial-x"></i></a>
                  <a href="#"><i className="jsocial-linkedin"></i></a>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-bottom-left">
              <p className="copyright-text">
                &copy; {currentYear} Callsoftbd. All rights reserved.
              </p>
            </div>
            <div className="footer-bottom-right">
              <p>Professional IT Products &amp; Services in Bangladesh and whole world</p>
            </div>
          </div>
        </div>
      </footer>

      <QuoteModal />
    </>
  );
}
